(function ($) {
	// Reserved quantity variation attribute.
	// Nort requested that pa_kolicina is used as an internal quantity-range selector.
	// For now this is intentionally hardcoded because the feature is client-specific.
	// If this behavior needs to support more clients/attributes later, this should be moved
	// to a configurable setting or exposed through a data attribute.
	const AUTO_QUANTITY_ATTRIBUTE = 'pa_kolicina';

	class W4D_ProductQuantity {
		constructor() {
			this.bindEvents();
			this.updateTimeout = null;
			this.isUpdating = false;
			this.isStepping = false;
			this.lastActionWasStepper = false;
		}

		bindEvents() {
			$(document).on('keydown', '.product-quantity__number', (e) => this.handleArrowPressInQuantity(e));

			$(document).on('mousedown', 'button[data-js-stepper]', () => {
				this.isStepping = true;
			});
			$(document).on('mouseup', 'button[data-js-stepper]', () => {
				setTimeout(() => {
					this.isStepping = false;
				}, 100);
			});

			$(document).on('click', 'button[data-js-stepper]', (e) => {
				e.preventDefault();
				e.stopPropagation();

				const $button = $(e.currentTarget);
				const action = $button.data('js-stepper'); // 'minus' ili 'plus'
				const $container = $button.closest('.product-quantity');

				this.handleQuantityChange($container, action);
			});

			$(document).on('focusout', '.product-quantity', (e) => this.handleQuantityFocusOut(e));
			$(document).on('focusin', '.product-quantity__number', (e) => this.handleQuantityFocusIn(e));
			$(document).on('input', '.product-quantity__number', (e, data) => this.handleDirectInputChange(e, data));
			$(document).on('click', '.product-table .product-quantity__cart', (e) => e.stopPropagation());
			$(document).on('click', '.product-quantity__cart', (e) => {
				const $button = $(e.currentTarget);
				const $input = $button.parent().find('.product-quantity__number').first();
				const location = $input.data('location');
				if (location === 'naruceni-artikli' || location === 'moji-artikli') {
					this.handleSingleQuantityUpdate($input[0], location);
				}
			});

			// Initial auto-quantity selection on page load
			$(document).ready(() => {
				$('[data-js-auto-quantity-variation-selection="1"]').each((i, container) => {
					const $container = $(container);
					const $input = $container.find('.product-quantity__number').first();
					if ($input.length) {
						this.handleAutoQuantityVariationSelection($input);
					}
				});
			});
		}

		handleArrowPressInQuantity(e) {
			if (e.key === 'Enter') {
				e.preventDefault();
				let $input = $(e.target);
				let location = $input.data('location');
				if (location === 'quick-order') {
					return;
				}
				let currentValue = parseFloat($input.val().replace(',', '.')) || 0;

				let step = parseFloat($input.attr('step') || 1);
				let decimalPlaces = step.toString().includes('.') ? step.toString().split('.')[1].length : 0;

				let formattedValue = currentValue.toFixed(decimalPlaces);
				let cleanValue = parseFloat(formattedValue).toString();
				let displayValue = cleanValue.replace('.', ',');

				$input.val(displayValue).attr('value', cleanValue).trigger('change');

				document.activeElement.blur();
				return;
			}
			if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
				e.preventDefault();
				let $input = $(e.target);
				let min = parseFloat($input.attr('min') || 0);
				let maxValue = parseFloat($input.attr('max'));
				let step = parseFloat($input.attr('step') || 1);
				let currentVal = parseFloat($input.val().replace(',', '.')) || 0;
				let newVal = e.key === 'ArrowUp' ? currentVal + step : currentVal - step;

				newVal = Math.max(min, newVal);
				newVal = Math.min(maxValue, newVal);

				// Format with appropriate decimal places based on step
				let decimalPlaces = step.toString().includes('.') ? step.toString().split('.')[1].length : 0;

				// Format the number with decimal places
				let formattedValue = newVal.toFixed(decimalPlaces);

				// Remove trailing zeros and decimal point if needed
				let cleanValue = parseFloat(formattedValue).toString();
				let displayValue = cleanValue.replace('.', ',');

				this.lastActionWasStepper = true;
				$input
					.val(displayValue)
					.attr('value', cleanValue)
					.trigger('input', [{ isArrow: true }]);

				if (location === 'variable-product' || location === 'single-product' || location === 'product-flyout') {
					this.handleAutoQuantityVariationSelection($input);
				}
			}
		}

		handleDirectInputChange(e, data) {
			const isArrow = data && data.isArrow;
			if (!isArrow) {
				this.lastActionWasStepper = false;
			}
			let $input = $(e.target);
			let startingValue = $input.data('starting-value');
			let originalValue = parseFloat($input.data('quantity'));
			let validationResult = W4D_ProductQuantityHelper.validateProductQuantityDirectInput(e.target, e);
			let location = $input.data('location');
			$input.attr('value', validationResult.numericValue);
			if (location === 'cart') {
				window.W4D_Cart.noteCartQuantityEdit($input);
			}

			if (location === 'table-view' || location === 'naruceni-artikli' || location === 'moji-artikli') {
				let $container = $input.parent();
				if (validationResult.numericValue !== originalValue || location === 'naruceni-artikli' || location === 'moji-artikli') {
					$container.addClass('product-quantity--changed');
				} else {
					$container.removeClass('product-quantity--changed');
				}
			}

			if (location === 'quick-order') {
				const $row = $input.closest('.quick-order__row');
				const rowIndex = $row.index();
				W4D_QuickOrder.updateLocalStorageQuantity(rowIndex, validationResult.numericValue);
			}

			if (
				location === 'product-card' ||
				location === 'product-flyout' ||
				location === 'single-product' ||
				location === 'variable-product'
			) {
				if ($input && $input.length && validationResult && validationResult.numericValue !== undefined) {
					const $sidebarContent = $input.closest(
						'.product-card, .product-flyout, .shop-sidebar, .product-quantity-add-to-cart-wrapper'
					);
					const actionButton = $sidebarContent.find('.w4d_add_to_cart_button').first();
					const isDual = $input.hasClass('js-jm1') || $input.hasClass('js-jm2');

					// Step 5-7: Always update auto-quantity selection/warning on each keystroke
					const $vContainer = $input.closest('.variations_container');
					if ($vContainer.length && $vContainer.attr('data-js-auto-quantity-variation-selection') === '1') {
						this.handleAutoQuantityVariationSelection($input);
					}

					if (actionButton.length) {
						// For dual inputs, we disable the button as soon as typing starts (and it's different from start)
						// For single inputs, we keep it enabled as requested by the user
						if ($input.val() === startingValue || !isDual || this.lastActionWasStepper) {
							let shouldEnable = true;
							if ($vContainer.length) {
								const varId = parseInt(actionButton.data('variation-id') || actionButton.attr('data-variation-id'));
								if (!varId || varId <= 0 || actionButton.hasClass('is-auto-quantity-invalid')) {
									shouldEnable = false;
								}
							}
							if (shouldEnable) {
								actionButton.prop('disabled', false).removeClass('is-typing');
							}
						} else {
							actionButton.prop('disabled', true).addClass('is-typing');
						}
					}

					// Always sync quantity to button and other inputs (if dual)
					// This ensures the button's data-quantity is rounded even during typing
					this.handleSidebarQuantityUpdate($input[0]);
				}
			}
		}

		handleQuantityChange(container, action) {
			this.lastActionWasStepper = true;
			let input = container.find('.product-quantity__number');
			let currentValue = parseFloat(input.val().replace(',', '.')) || 0;
			let originalValue = parseFloat(input.data('quantity'));
			let step = parseFloat(input.attr('step') || 1);
			let max = parseFloat(input.attr('max'));
			let min = parseFloat(input.attr('min') || 0);
			let location = input.data('location');

			if (action === 'plus' && currentValue < max) {
				currentValue += step;
			} else if (action === 'minus' && currentValue > min) {
				currentValue = Math.max(min, currentValue - step);
			}

			// Round to the same precision as the step value
			const decimalPlaces = step.toString().includes('.') ? step.toString().split('.')[1].length : 0;
			currentValue = parseFloat(currentValue.toFixed(decimalPlaces));

			if (location === 'table-view' || location === 'naruceni-artikli' || location === 'moji-artikli') {
				if (currentValue === originalValue && location !== 'naruceni-artikli' && location !== 'moji-artikli') {
					container.removeClass('product-quantity--changed');
				} else {
					container.addClass('product-quantity--changed');
				}
			}

			if (location === 'quick-order') {
				const $row = input.closest('.quick-order__row');
				const rowIndex = $row.index();
				W4D_QuickOrder.updateLocalStorageQuantity(rowIndex, currentValue);
			}

			let displayValue = currentValue.toString().replace('.', ',');
			input.val(displayValue).attr('value', currentValue).trigger('change');
			if (location === 'cart') {
				window.W4D_Cart.scheduleCartQuantityUpdate(input);
			}

			if (
				location === 'single-product' ||
				location === 'variable-product' ||
				location === 'product-card' ||
				location === 'product-flyout'
			) {
				const $sidebarContent = input.closest(
					'.shop-sidebar, .product-card, .product-flyout, .product-quantity-add-to-cart-wrapper'
				);
				const $actionButton = $sidebarContent.find('.w4d_add_to_cart_button');

				if ($actionButton.length) {
					$actionButton.removeClass('is-typing');
				}

				this.handleSidebarQuantityUpdate(input);

				this.handleAutoQuantityVariationSelection(input);

				if ($actionButton.length) {
					let shouldEnable = true;
					const $vContainer = $actionButton.closest('.variations_container');
					if ($vContainer.length) {
						const varId = parseInt($actionButton.data('variation-id') || $actionButton.attr('data-variation-id'));
						if (!varId || varId <= 0) {
							shouldEnable = false;
						}
					}
					if (shouldEnable && !$actionButton.hasClass('loading')) {
						// Ensure auto-selection is updated before re-enabling
						this.handleAutoQuantityVariationSelection(input);

						const finalVarId = parseInt($actionButton.data('variation-id') || $actionButton.attr('data-variation-id'));
						if (finalVarId && finalVarId > 0) {
							$actionButton.prop('disabled', false);
						}
					}
				}
			}
		}

		handleQuantityFocusIn(e) {
			if (this.isStepping) {
				this.lastActionWasStepper = true;
				return;
			}
			this.lastActionWasStepper = false;

			const $input = $(e.target);

			// Store the value when entering focus to allow comparison during typing
			$input.data('starting-value', $input.val());
		}

		handleQuantityFocusOut(e) {
			const $container = $(e.currentTarget);
			const $target = $(e.target);
			const $input = $target.is('.product-quantity__number') ? $target : $container.find('.product-quantity__number').first();
			const location = $input.data('location');

			if (location === 'naruceni-artikli' || location === 'moji-artikli') {
				return;
			}
			if (location === 'cart') {
				window.W4D_Cart.scheduleCartQuantityUpdate($input);
				return;
			}

			if (this.updateTimeout) {
				clearTimeout(this.updateTimeout);
			}

			// Capture original value before we potentially update it via sync
			let originalValue = parseFloat($input.data('quantity'));

			const isStepper =
				this.isStepping ||
				this.lastActionWasStepper ||
				(e.relatedTarget && $(e.relatedTarget).closest('[data-js-stepper]').length > 0);

			const currentValNum = parseFloat($input.val().replace(',', '.')) || 0;
			const isDual = $input.hasClass('js-jm1') || $input.hasClass('js-jm2');
			const hasChanged = $input.val() !== $input.data('starting-value') || currentValNum !== originalValue;

			const shouldShowRecalculating = !isStepper && hasChanged && isDual;

			// Sinkroniziraj polja (ako je dual) i odradi rounding ODMAH na blur
			this.handleSidebarQuantityUpdate($input[0], shouldShowRecalculating);

			this.handleAutoQuantityVariationSelection($input);

			this.lastActionWasStepper = false;

			// Provjeri je li fokus i dalje unutar container-a
			this.updateTimeout = setTimeout(() => {
				const activeEl = document.activeElement;

				// Fokus je i dalje unutar komponente
				const focusStillInside = $container.has(activeEl).length || $container.is(activeEl);

				// Ako je ovo dual input (JM1/JM2) i fokus je prešao na drugi field unutar iste komponente,
				// NE radimo cart update.
				const isDual = $input.hasClass('js-jm1') || $input.hasClass('js-jm2');
				const movingToAnotherInput = $(activeEl).hasClass('product-quantity__number');

				// Makni trailing decimal separator ako je ostao na inputu koji je izgubio fokus
				let inputValue = String($input.val() || '');
				if (inputValue.endsWith('.') || inputValue.endsWith(',')) {
					inputValue = inputValue.slice(0, -1);
					$input.val(inputValue);
				}

				// Ako je ovo dual input i prelazimo s jednog na drugi, nemoj još okidati update
				if (focusStillInside && movingToAnotherInput && isDual) {
					return;
				}

				// Dodatna provjera: da li je update već u tijeku?
				if (this.isUpdating) {
					return;
				}

				let currentValue = parseFloat($input.val().replace(',', '.'));
				if (isNaN(currentValue)) currentValue = 0;

				// Rano vraćanje ako vrijednost nije promijenjena
				if (currentValue === originalValue) {
					return;
				}

				// Postavi flag prije update-a
				this.isUpdating = true;

				if (location === 'variable-product' || location === 'single-product' || location === 'product-flyout') {
					// Već odrađeno gore kroz handleSidebarQuantityUpdate
				} else if (location === 'table-view' || location === 'quick-order' || location === 'product-card') {
					this.handleSingleQuantityUpdate($input[0], location);
				}

				// Reset flag nakon što se update završi (ili nakon određenog vremena)
				setTimeout(() => {
					this.isUpdating = false;
				}, 500);
			}, 300);
		}

		handleAutoQuantityVariationSelection($input) {
			const $productSidebar = $input.closest('.variations_container');

			if ($productSidebar.attr('data-js-auto-quantity-variation-selection') === undefined) {
				return;
			}

			const $actionButton = $productSidebar.find('.w4d_add_to_cart_button').first();
			const quantity = parseFloat($input.attr('value') || $input.val().replace(',', '.')) || 0;

			const $select = this.getAutoQuantitySelect($productSidebar);

			if (!$select.length) {
				return;
			}

			const ranges = this.getAutoQuantityRanges($select);
			const match = this.findAutoQuantityRangeMatch(quantity, ranges);

			if (match) {
				if ($select.val() !== match.raw) {
					$select.val(match.raw).trigger('change');
				}
				this.clearAutoQuantityRangeWarning($input);
				$actionButton.removeClass('is-auto-quantity-invalid');

				// Update data-variation-id on the add to cart button
				const variations = $productSidebar.data('product_variations');

				if (variations && variations.length) {
					const selectedAttributes = {};
					$productSidebar.find('.variations select').each((i, s) => {
						const $s = $(s);
						selectedAttributes['attribute_' + $s.data('attribute_name')] = $s.val();
					});

					const matchingVariation = variations.find((v) => {
						return Object.keys(v.attributes).every((attr) => {
							const variationValue = v.attributes[attr];
							const selectedValue = selectedAttributes[attr];
							// Match if:
							// 1. The variation's attribute value matches the selected value
							// 2. The variation's attribute value is empty (wildcard)
							return variationValue === selectedValue || variationValue === '';
						});
					});

					if (matchingVariation) {
						$actionButton
							.attr('data-variation-id', matchingVariation.variation_id)
							.data('variation-id', matchingVariation.variation_id);

						// Also update quantity data on button just in case
						$actionButton.attr('data-quantity', quantity).data('quantity', quantity);
					} else {
						console.error('W4D-AutoQty: No matching variation found for current attributes');
					}
				}
				// WooCommerce variation logic will handle button enabling/disabling from here
			} else {
				if ($select.val() !== '') {
					$select.val('').trigger('change');
				}
				const maxValue = this.getAutoQuantityMaxValue(ranges);
				const message = maxValue !== null ? `Max. količina = ${maxValue}` : 'Količina je izvan dostupnog raspona';
				this.setAutoQuantityRangeWarning($input, message);
				$actionButton
					.prop('disabled', true)
					.addClass('is-auto-quantity-invalid')
					.attr('data-variation-id', 0)
					.data('variation-id', 0);
			}
		}

		getAutoQuantitySelect($container) {
			return $container.find(`select[name="attribute_${AUTO_QUANTITY_ATTRIBUTE}"]`);
		}

		getAutoQuantityRanges($select) {
			const ranges = [];
			$select.find('option').each((i, option) => {
				const $option = $(option);
				const rawValue = $option.val();
				if (!rawValue) return;

				const parsed = this.parseAutoQuantityOption(rawValue);
				if (parsed) {
					ranges.push(parsed);
				}
			});
			return ranges;
		}

		parseAutoQuantityOption(rawValue) {
			const value = rawValue.trim();

			// Exact: "1", "2"
			if (/^\d+$/.test(value)) {
				const n = parseInt(value, 10);
				return { raw: rawValue, value, min: n, max: n, type: 'exact' };
			}

			// Plus: "11+", "11 +", "11  +"
			const plusMatch = value.match(/^(\d+)\s*\+$/);
			if (plusMatch) {
				const n = parseInt(plusMatch[1], 10);
				return { raw: rawValue, value, min: n, max: Infinity, type: 'plus' };
			}

			// Range: "4-10", "4 - 10"
			const rangeMatch = value.match(/^(\d+)\s*-\s*(\d+)$/);
			if (rangeMatch) {
				const min = parseInt(rangeMatch[1], 10);
				const max = parseInt(rangeMatch[2], 10);
				if (min <= max) {
					return { raw: rawValue, value, min, max, type: 'range' };
				}
			}

			return null;
		}

		// Returns the largest finite upper bound across parsed ranges, or null if open-ended/none.
		getAutoQuantityMaxValue(ranges) {
			if (!ranges || !ranges.length) {
				return null;
			}
			// Open-ended range (e.g. "11+") means there is no real maximum.
			if (ranges.some((r) => r.max === Infinity)) {
				return null;
			}
			return Math.max(...ranges.map((r) => r.max));
		}

		findAutoQuantityRangeMatch(quantity, ranges) {
			for (const range of ranges) {
				if (quantity >= range.min && quantity <= range.max) {
					return range;
				}
			}
			return null;
		}

		setAutoQuantityRangeWarning($input, message) {
			const $container = $input.closest('.product-quantity');
			$container.addClass('product-quantity--range-warning').attr('data-quantity-range-message', message);
		}

		clearAutoQuantityRangeWarning($input) {
			const $container = $input.closest('.product-quantity');
			$container.removeClass('product-quantity--range-warning').removeAttr('data-quantity-range-message');
		}

		handleSingleQuantityUpdate(input, location) {
			const $input = $(input);
			const val = $input.val().replace(',', '.');
			const inputValue = parseFloat(val);

			if (
				location === 'table-view' ||
				location === 'variable-product' ||
				location === 'naruceni-artikli' ||
				location === 'moji-artikli'
			) {
				const $step = parseFloat($input.attr('step'));
				const $step_decimal_places = W4D_ProductQuantityHelper.getDecimalPlaces($step);
				const remainder = inputValue % $step;
				let roundedValue;

				if (remainder > 0) {
					// Ako vrijednost nije višekratnik koraka, zaokruži na sljedeći višekratnik
					roundedValue = W4D_ProductQuantityHelper.roundToDecimalPlaces(
						Math.ceil(inputValue / $step) * $step,
						$step_decimal_places
					);
				} else {
					// Vrijednost je već višekratnik koraka, zadrži je kakva jest
					roundedValue = inputValue;
				}

				const displayValue = String(roundedValue).replace('.', ',');

				$input
					.val(displayValue)
					.attr('value', roundedValue)
					.attr('data-quantity', roundedValue)
					.data('quantity', roundedValue)
					.trigger('change');

				if (location === 'table-view' || location === 'naruceni-artikli' || location === 'moji-artikli') {
					W4D_Cart.handleUpdateCart($input);
				}
			}
		}

		handleSidebarQuantityUpdate(input, isBlur = false) {
			const $input = $(input);
			const val = $input.val().replace(',', '.');
			let numericValue = parseFloat(val);

			const $step = parseFloat($input.attr('step'));
			const $min = parseFloat($input.attr('min') || 0);
			const $step_decimal_places = W4D_ProductQuantityHelper.getDecimalPlaces($step);
			const $faktor = parseFloat($input.data('faktor') || 1);

			let $sidebarContent = $input.closest('.shop-sidebar, .product-card, .product-flyout, .product-quantity-add-to-cart-wrapper');
			const $actionButton = $sidebarContent.find('.w4d_add_to_cart_button');

			// Visually disable while rounding/recalculating on blur
			if (isBlur) {
				const $inputs =
					$input.hasClass('js-jm1') || $input.hasClass('js-jm2')
						? $input.closest('.product-quantity__dual').find('.product-quantity__number')
						: $input;

				$inputs.prop('readonly', true).addClass('is-recalculating');
				if ($actionButton.length) {
					$actionButton.prop('disabled', true).addClass('is-recalculating');
				}
			}

			// Handle rounding to step and min for non-empty values
			if (!isNaN(numericValue) && val !== '') {
				const remainder = numericValue % $step;
				if (remainder > 0.0000001) {
					// Floating point precision buffer
					numericValue = W4D_ProductQuantityHelper.roundToDecimalPlaces(
						Math.ceil(numericValue / $step) * $step,
						$step_decimal_places
					);
				}

				if (numericValue < $min) {
					numericValue = $min;
				}
			}

			if ($faktor !== 1 && ($input.hasClass('js-jm1') || $input.hasClass('js-jm2'))) {
				let $jm1_input, $jm2_input;
				let $jm1_val, $jm2_val;
				let $jm1_display, $jm2_display;

				if (isNaN(numericValue) || val === '') {
					$jm1_input = $input.hasClass('js-jm1') ? $input : $input.parent().parent().find('.js-jm1');
					$jm2_input = $input.hasClass('js-jm2') ? $input : $input.parent().parent().find('.js-jm2');

					$jm1_display = '';
					$jm2_display = '';
					$jm1_val = 0;
					$jm2_val = 0;
				} else {
					if ($input.hasClass('js-jm1')) {
						$jm1_input = $input;
						$jm2_input = $jm1_input.parent().parent().find('.js-jm2');
						$jm1_val = numericValue;
						let $jm2_step = parseFloat($jm2_input.attr('step'));
						let $jm2_step_decimal_places = W4D_ProductQuantityHelper.getDecimalPlaces($jm2_step);

						$jm2_val = W4D_ProductQuantityHelper.roundToDecimalPlaces($jm1_val * $faktor, $jm2_step_decimal_places);
					} else {
						$jm2_input = $input;
						$jm1_input = $jm2_input.parent().parent().find('.js-jm1');
						$jm2_val = numericValue;
						let $jm1_step = parseFloat($jm1_input.attr('step'));
						let $jm1_step_decimal_places = W4D_ProductQuantityHelper.getDecimalPlaces($jm1_step);

						$jm1_val = W4D_ProductQuantityHelper.roundToDecimalPlaces($jm2_val / $faktor, $jm1_step_decimal_places);
					}
					$jm1_display = String($jm1_val).replace('.', ',');
					$jm2_display = String($jm2_val).replace('.', ',');
				}

				if ($jm1_input[0] !== document.activeElement) {
					$jm1_input.val($jm1_display);
				}
				$jm1_input.attr('value', $jm1_val).attr('data-quantity', $jm1_val).data('quantity', $jm1_val).trigger('change');

				if ($jm2_input[0] !== document.activeElement) {
					$jm2_input.val($jm2_display);
				}
				$jm2_input.attr('value', $jm2_val).attr('data-quantity', $jm2_val).data('quantity', $jm2_val).trigger('change');
			} else {
				if (isNaN(numericValue) || val === '') {
					if ($input[0] !== document.activeElement) {
						$input.val('');
					}
					$input.attr('value', 0).attr('data-quantity', 0).data('quantity', 0).trigger('change');
				} else {
					const displayValue = String(numericValue).replace('.', ',');

					if ($input[0] !== document.activeElement) {
						$input.val(displayValue);
					}
					$input.attr('value', numericValue).attr('data-quantity', numericValue).data('quantity', numericValue).trigger('change');
				}
			}

			if ($actionButton.length) {
				const currentValue = parseFloat($input.attr('value'));

				$actionButton.attr('data-quantity', currentValue).data('quantity', currentValue);
			}

			if (isBlur) {
				setTimeout(() => {
					const activeEl = document.activeElement;
					const focusStillInProduct = $sidebarContent.has(activeEl).length && $(activeEl).hasClass('product-quantity__number');

					const $inputs =
						$input.hasClass('js-jm1') || $input.hasClass('js-jm2')
							? $input.closest('.product-quantity__dual').find('.product-quantity__number')
							: $input;

					$inputs.prop('readonly', false).removeClass('is-recalculating');

					if ($actionButton.length) {
						$actionButton.removeClass('is-recalculating').removeClass('is-typing');

						// Only re-enable if focus moved out of the product's quantity inputs entirely
						if (!focusStillInProduct && !$actionButton.hasClass('loading')) {
							let shouldEnable = true;
							const $vContainer = $actionButton.closest('.variations_container');
							if ($vContainer.length) {
								// IMPORTANT: Call selection here too
								this.handleAutoQuantityVariationSelection($input);
								const varId = parseInt($actionButton.data('variation-id') || $actionButton.attr('data-variation-id'));
								if (!varId || varId <= 0 || $actionButton.hasClass('is-auto-quantity-invalid')) {
									shouldEnable = false;
								}
							}

							if (shouldEnable) {
								$actionButton.prop('disabled', false);
							}
						}
					}
				}, 300);
			}
		}
	}

	$(document).ready(function () {
		window.W4D_ProductQuantity = new W4D_ProductQuantity();
	});
})(jQuery);
